module.exports = __webpack_public_path__ + "img/close-2.6e45bcc4.png";